import { Level } from '@susu/custom-made/utils/constants';

export enum actions {
  SELECT_SECTION = 'SELECT_SECTION',
  SELECT_LEVEL = 'SELECT_LEVEL',
}

export interface NavigationStateProps {
  section: string | null;
  level: Level;
}

export const initialState: NavigationStateProps = {
  section: null,
  level: Level.Group,
};

interface SelectNavigationAction {
  type: actions.SELECT_SECTION;
  payload: string;
}

interface SelectLevelAction {
  type: actions.SELECT_LEVEL;
  payload: string;
}

export type NavigationActionTypes = SelectNavigationAction | SelectLevelAction;

export default function NavigationReducer(state: NavigationStateProps, action: SelectNavigationAction) {
  if (action.type === actions.SELECT_SECTION) {
    return { ...state, section: action.payload };
  } else if (action.type === actions.SELECT_LEVEL) {
    return { ...state, level: action.payload };
  } else {
    return state;
  }
}
